import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { units } from '@hbf/dsl';
import WaveDesktop from 'ha/img-src/wave-bg-desktop.svg';
import WaveMobile from 'ha/img-src/wave-bg-mobile.svg';

export const useStyles = makeStyles()(t => ({
  separator: {
    height: units.rem(3.5),
    backgroundImage: `url(${WaveMobile})`,
    backgroundRepeat: 'repeat-x',
    backgroundPosition: 'bottom left',
    [t.breakpoints.up('sm')]: {
      height: units.rem(5),
      backgroundImage: `url(${WaveDesktop})`,
    },
  },
  rotate: {
    transform: 'rotate(180deg)',
  },
}));

interface Props {
  rotate?: boolean;
}

export const Separator: React.FC<Props> = ({ rotate = false }) => {
  const { classes, cx } = useStyles();
  return (
    <div className={cx(rotate ? classes.rotate : null, classes.separator)} />
  );
};
